// extracted by mini-css-extract-plugin
module.exports = {"container":"Event_container__3UDtW","heading":"Event_heading__2HZ2j"};